var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isBusy,
              expression: "isBusy",
            },
          ],
          ref: "form",
          attrs: { model: _vm.form, rules: _vm.rules },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Send List", prop: "send_list_id" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "w-100",
                  attrs: {
                    filterable: "",
                    clearable: "",
                    remote: "",
                    placeholder: "Search",
                    "remote-method": _vm.searchSendList,
                    loading: _vm.sendListLoading,
                    disabled: !_vm.canChangeSendList,
                  },
                  model: {
                    value: _vm.form.send_list_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "send_list_id", $$v)
                    },
                    expression: "form.send_list_id",
                  },
                },
                _vm._l(_vm.sendLists, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Status", prop: "status" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "w-100",
                  attrs: { disabled: !_vm.canChangeStatus },
                  model: {
                    value: _vm.form.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "status", $$v)
                    },
                    expression: "form.status",
                  },
                },
                _vm._l(_vm.statuses, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Start At", prop: "start_at" } },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "datetime",
                  placeholder: "Start",
                  disabled: !_vm.canChangeStartAt,
                  format: _vm.dateFormat,
                  "value-format": _vm.formDateFormat,
                },
                model: {
                  value: _vm.form.start_at,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "start_at", $$v)
                  },
                  expression: "form.start_at",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Stop At", prop: "stop_at" } },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "datetime",
                  placeholder: "Stop",
                  disabled: !_vm.canChangeStopAt,
                  format: _vm.dateFormat,
                  "value-format": _vm.formDateFormat,
                },
                model: {
                  value: _vm.form.stop_at,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "stop_at", $$v)
                  },
                  expression: "form.stop_at",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Message", prop: "body" } },
            [
              _c("el-input", {
                ref: "body",
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 2, maxRows: 6 },
                  disabled: !_vm.canChangeBody,
                },
                model: {
                  value: _vm.form.body,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "body", $$v)
                  },
                  expression: "form.body",
                },
              }),
              _vm._v(" "),
              _c("message-tools", {
                on: { "insert-value": _vm.insertValueIntoMessage },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.save } },
                [_vm._v("Save")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }